import { writable } from 'svelte/store';
import type { NotificationSettings } from '$lib/domain/types';
import { notificationRepo } from '$lib/db/repo';
import { syncEngine } from './sync';

const createNotificationStore = () => {
  let loaded = false;
  const { subscribe, set, update } = writable<NotificationSettings>({
    enabled: true,
    volume: 0.7,
    soundPack: 'aurora',
    playOn: {
      workComplete: true,
      breakComplete: true,
      planStart: true
    }
  });

  const load = async () => {
    const settings = await notificationRepo.get();
    set(settings);
    loaded = true;
  };

  const setSettings = async (next: NotificationSettings) => {
    await notificationRepo.set(next);
    await syncEngine.enqueueChange('notification_settings', 'default', { key: 'default', value: next });
    set(next);
    loaded = true;
  };

  const updateSettings = async (patch: Partial<NotificationSettings>) => {
    update((current) => {
      const next = { ...current, ...patch };
      notificationRepo.set(next);
      syncEngine.enqueueChange('notification_settings', 'default', { key: 'default', value: next });
      return next;
    });
  };

  return { subscribe, load, setSettings, updateSettings, isLoaded: () => loaded };
};

export const notificationStore = createNotificationStore();
